import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()
  const [api] = useState(() => ({
    planningRangeTitle: translate({ id: 'modals.planningRange.title' }),
    exportTitle: (exportDateInterval: string, exportedDays: number) =>
      translate({
        id: 'modals.planningRange.export.title',
        values: { exportDateInterval, exportedDays },
      }),

    deleteTitle: translate({ id: 'modals.planningRange.delete.title' }),
    deleteDescription: translate({ id: 'modals.planningRange.delete.description' }),
    deleteCheckOne: translate({ id: 'modals.planningRange.delete.check.one' }),
    deleteCheckTwo: translate({ id: 'modals.planningRange.delete.check.two' }),
    deleteCheckThree: translate({ id: 'modals.planningRange.delete.check.three' }),

    rangePickerTitle: translate({ id: 'modals.planningRange.rangePicker.title' }),

    rangePickerAlertwithErrorFull: (newPlanningRange: number) =>
      translate({
        id: 'modals.planningRange.rangePicker.alert.withErrorFull',
        values: { newPlanningRange },
      }),
    rangePickerAlertwithError: (newPlanningRange: number, percentage: number) =>
      translate({
        id: 'modals.planningRange.rangePicker.alert.withError',
        values: { newPlanningRange, percentage },
      }),
    rangePickerAlertwithWarning: (newPlanningRange: number, percentage: number) =>
      translate({
        id: 'modals.planningRange.rangePicker.alert.withWarning',
        values: { newPlanningRange, percentage },
      }),
    rangePickerAlertwithSuccess: (newPlanningRange: number, percentage: number) =>
      translate({
        id: 'modals.planningRange.rangePicker.alert.withSuccess',
        values: { newPlanningRange, percentage },
      }),
    rangePickerAlertWithStorageError: (newPlanningRange: number) =>
      translate({
        id: 'modals.planningRange.rangePicker.alert.withMaxStorageError',
        values: { newPlanningRange },
      }),
    rangePickerAlertWithMinInputErrorOutOfRange: (maxPlanningRange: number) =>
      translate({
        id: 'modals.planningRange.rangePicker.alert.withInputErrorOutOfRange',
        values: { maxPlanningRange },
      }),

    alertTitle: translate({ id: 'modals.planningRange.alert.title' }),
    alertDescription: translate({ id: 'modals.planningRange.alert.description' }),
    alertContentOne: translate({ id: 'modals.planningRange.alert.content.one' }),
    alertContentTwo: translate({ id: 'modals.planningRange.alert.content.two' }),

    buttonCancel: translate({ id: 'modals.planningRange.button.cancel' }),
    buttonApplyChanges: translate({ id: 'modals.planningRange.button.applyChanges' }),
    buttonApplyChangesAndDelete: translate({
      id: 'modals.planningRange.button.applyChangesAndDelete',
    }),
    buttonExportOrdersAndApplyChanges: translate({
      id: 'modals.planningRange.button.exportOrdersAndApplyChanges',
    }),
    buttonExportAndDeleteOrders: translate({
      id: 'modals.planningRange.button.exportAndDeleteOrders',
    }),
    buttonDelete: translate({ id: 'modals.planningRange.button.delete' }),

    learnMore: translate({ id: 'modals.planningRange.learnMore' }),

    formatCSV: translate({ id: 'modals.planningRange.exportFormat.csv' }),
    formatXLSX: translate({ id: 'modals.planningRange.exportFormat.xlsx' }),
    formatPDF: translate({ id: 'modals.planningRange.exportFormat.pdf' }),

    configurationTitle: translate({ id: 'modals.planningRange.configuration.title' }),
    configurationDescription: translate({
      id: 'modals.planningRange.configuration.description',
    }),
    formatTitle: translate({ id: 'modals.planningRange.format.title' }),
    orderDataTitle: translate({ id: 'modals.planningRange.orderData.title' }),

    updated: translate({ id: 'modals.planningRange.updated' }),
  }))

  return api
}
